<template>
  <section ref="timelineContainer" class="timeline">
    <div class="timeline__header">
      <button
        class="timeline__play-button"
        type="button"
        @click="playButtonClickHandler"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="18"
          viewBox="0 0 13 18"
          fill="none"
          v-if="!played"
        >
          <path id="Path" fill-rule="evenodd" clip-rule="evenodd" d="M12.4164 7.79418L2.07516 0.245578C1.19322 -0.399277 0 0.302477 0 1.45942V16.5377C0 17.7136 1.19322 18.3964 2.07516 17.7515L12.4164 10.2029C13.1945 9.65288 13.1945 8.36317 12.4164 7.79418Z" fill="#F5F5F5"/>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          v-if="played"
        >
          <rect x="3" width="4" height="16" rx="2" fill="#f5f5f5"/>
          <rect x="9" width="4" height="16" rx="2" fill="#f5f5f5"/>
        </svg>
      </button>
      <span class="timeline__current-times">{{ currentTimeMask.toFixed(2) }} / {{ durationMask.toFixed(2) }}</span>

      <button
        class="timeline__zoom-in"
        type="button"
        @click="zoomInClickHandler"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="2" viewBox="0 0 12 2" fill="none">
          <path d="M10.9297 0.928711L1.07262 0.92871" stroke="white" stroke-width="1.70716" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button
        class="timeline__zoom-out"
        type="button"
        @click="zoomOutClickHandler"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 1V10.8572" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.9297 5.92871L1.0725 5.92871" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <button
        class="timeline__max-zoom-out"
        type="button"
        @click="fitButtonClickHandler"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
          <path d="M0 10.1111C0 10.3174 0.0819442 10.5152 0.227806 10.6611C0.373667 10.8069 0.571498 10.8889 0.777778 10.8889C0.984057 10.8889 1.18189 10.8069 1.32775 10.6611C1.47361 10.5152 1.55556 10.3174 1.55556 10.1111V0.777778C1.55556 0.571498 1.47361 0.373668 1.32775 0.227806C1.18189 0.0819444 0.984057 0 0.777778 0C0.571498 0 0.373667 0.0819444 0.227806 0.227806C0.0819442 0.373668 0 0.571498 0 0.777778V10.1111Z" fill="white"/>
          <path d="M12.4453 10.1111C12.4453 10.3174 12.5273 10.5152 12.6731 10.6611C12.819 10.8069 13.0168 10.8889 13.2231 10.8889C13.4294 10.8889 13.6272 10.8069 13.7731 10.6611C13.9189 10.5152 14.0009 10.3174 14.0009 10.1111V0.777778C14.0009 0.571498 13.9189 0.373668 13.7731 0.227806C13.6272 0.0819444 13.4294 0 13.2231 0C13.0168 0 12.819 0.0819444 12.6731 0.227806C12.5273 0.373668 12.4453 0.571498 12.4453 0.777778V10.1111Z" fill="white"/>
          <path d="M8.38787 6.84409L8.32176 6.91953L8.31709 6.92575C8.2002 7.08355 8.14733 7.27971 8.16908 7.47487C8.19084 7.67003 8.2856 7.84974 8.43436 7.97792C8.58312 8.10611 8.77486 8.17328 8.9711 8.16595C9.16733 8.15862 9.35353 8.07734 9.49231 7.93842L11.3201 6.1122C11.5332 5.97298 11.6654 5.7202 11.6654 5.44331C11.6654 5.16642 11.5332 4.91364 11.3201 4.77442L9.48765 2.94353L9.41142 2.87742L9.4052 2.87353C9.25546 2.76259 9.07086 2.70911 8.885 2.72281C8.69915 2.73651 8.52439 2.8165 8.39253 2.9482L8.38787 2.95364L8.32176 3.02986L8.31709 3.03531C8.20625 3.18514 8.1529 3.36979 8.16674 3.55565C8.18059 3.74151 8.26072 3.91622 8.39253 4.04798L9.01009 4.66631H6.52898L6.51187 4.66786H4.98742L5.61042 4.04409L5.68276 3.95853L5.68742 3.95231C5.7831 3.8185 5.83389 3.65781 5.83249 3.49332C5.83109 3.32883 5.77758 3.16903 5.67965 3.03686L5.67576 3.03064L5.60498 2.94898L5.51398 2.8712L5.50776 2.86731C5.37395 2.77164 5.21326 2.72085 5.04877 2.72224C4.88428 2.72364 4.72447 2.77715 4.59231 2.87509L4.58609 2.87898L4.50987 2.94431L2.67431 4.77909L2.62376 4.81409L2.61831 4.81875C2.52738 4.89538 2.45455 4.99119 2.40506 5.09932C2.35557 5.20744 2.33065 5.32518 2.33209 5.44409C2.33209 5.72098 2.46431 5.97375 2.67665 6.11298L4.50987 7.94464L4.58609 8.01075L4.59231 8.01464C4.74211 8.12585 4.92689 8.1795 5.11296 8.16582C5.29902 8.15213 5.47397 8.07203 5.60589 7.94011C5.73781 7.80818 5.81792 7.63324 5.8316 7.44718C5.84528 7.26111 5.79163 7.07633 5.68042 6.92653L5.67576 6.92109L5.60965 6.84486L4.98742 6.22264H7.46853L7.48565 6.22186H9.01009L8.38787 6.84409Z" fill="white"/>
        </svg>
      </button>
    </div>
    <div
      class="timeline__canvas-wrapper"
    >
      <canvas
        ref="timelineCanvas"
        class="timeline__canvas"
        :width="canvasWidth"
        :height="canvasHeight"
        @mouseup="canvasMouseupEventHandler($event)"
        @mousedown="canvasMousedownEventHandler($event)"
        @mousemove="canvasMousemoveEventHandler($event)"
        @mouseleave="canvasMouseleaveEventHandler()"
      ></canvas>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    source: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    speed: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentTime: {
      type: Number,
      required: true,
    },
    id: {
      type: String,
      required: true,
    }
  },
  // Высота зоны с засечками - 27
  // Высота зоны для дорожки с оверлеем - 24
  // Высота отступов между дорожками (и паддинга внизу) - 8
  // Высота зоны для дорожки с видео - 56

  // Минимальная высота канваса - засечки + дорожка с видео + отступ между ними и внизу: 27 + 56 + 8 + 8 = 99 пикселей
  // Максимальная высота канваса - засечки + 3 зоны под оверлеи
  // и музыку + 4 отступа = 27 + 24 * 3 + 8 * 4 = 131 (186, надо пересчитать)
  data() {
    return {
      openedSourceId: undefined,
      runningProcesses: 0,

      // Ширина канваса
      canvasWidth: 20000,

      // Высота канваса
      canvasHeight: 99,

      // Сдвиг координатной оси от левого края канваса
      canvasAxialOffset: 5,

      // Коэффициент масштабирования, используется при конвертации секунд в пиксели.
      // Показывает сколько пикселей по ширине выделяется для одной секунды
      scalingFactor: 50,

      // Режим перетаскивания плейхеда
      dragMode: false,

      // Режим сгвига одной из границ видео 'left' для левой и 'right' для правой
      cutOffMode: false,

      // Цена деления таймлайна
      scaleDivisionValue: 5,

      mainVideoTrackHeight: 56,
      axialHeight: 27,
      overlayTrackHeight: 27,
      tracksPadding: 8,

      mainVideoTrackHover: false,
      leftVideoBorderHover: false,
      rightVideoBorderHover: false,

      animation: null,
      played: false,
      thumbs: {},

      thumbsCheckInterval: undefined,
    }
  },
  computed: {
    currentTimeMask() {
      return Math.round(this.currentTime * 100) / 100
    },
    durationMask() {
      return Math.round(((this.value.finishTime - this.value.startTime) / this.speed) * 100) / 100
    },

    /**
     * Значение y-ой координаты для якоря дорожки с видео
     * UPD: это значение пересчитывается, т.к. внутри канваса будет скролл по оси y
     */
    mainVideoTrackMargin() {
      return this.axialHeight + this.tracksPadding
    }
  },
  methods: {
    playButtonClickHandler() {
      this.played = !this.played
      this.$emit('onPlay', this.played)
    },
    zoomOutClickHandler() {
      if (this.scalingFactor < 100) {
        this.scalingFactor += 10
      }
    },
    zoomInClickHandler() {
      if (this.scalingFactor > 30) {
        this.scalingFactor -= 10
      }
      if (this.scalingFactor <= 30 && this.scalingFactor > 10) {
        this.scalingFactor -= 1
      }
    },
    fitButtonClickHandler() {
      this.scalingFactor = Math.round((this.$refs.timelineContainer.clientWidth - 20) / (this.duration / this.speed))
    },
    canvasMouseupEventHandler(event) {
      if (this.cutOffMode) {
        this.$emit('stopDrag', this.value.startTime)
        this.cutOffMode = false
        this.played = false
      }
      this.dragMode = false
    },
    canvasMousedownEventHandler(event) {
      // Если при клике видео не стояло на паузе
      if (this.played) {
        this.playButtonClickHandler()
      }

      // Просчитываем текущие "границы" блока с основным видео, чтобы отлавливать ховер внутри этих границ
      const leftBorder = ((this.value.startTime * this.scalingFactor) / this.speed) + this.canvasAxialOffset
      const rightBorder = ((this.value.finishTime * this.scalingFactor) / this.speed) + this.canvasAxialOffset
      const topBorder = this.axialHeight + this.tracksPadding
      const bottomBorder = this.axialHeight + this.tracksPadding + this.mainVideoTrackHeight

      // Просчитываем текущие координаты курсора
      const loc = this.windowToCanvas(this.$refs.timelineCanvas, event.clientX, event.clientY)

      // Клик по левой границе видео
      if (
        Math.abs(leftBorder - loc.x) < 30
        && loc.y >= topBorder
        && loc.y <= bottomBorder
      ) {
        this.cutOffMode = 'left'
        return
      }

      // Клик по правой границе видео
      if (
        Math.abs(rightBorder - loc.x) < 30
        && loc.y >= topBorder
        && loc.y <= bottomBorder
      ) {
        this.cutOffMode = 'right'
        return
      }

      // Клик внутри границ видео, но не по краям (перетаскивание плейхеда)
      if (loc.x > (this.value.startTime / this.speed * this.scalingFactor) && loc.x < (this.value.finishTime / this.speed * this.scalingFactor)) {
        this.dragMode = true
        this.calculateTime(loc.x)
      }
    },
    canvasMousemoveEventHandler(event) {
      // Просчитываем текущие "границы" блока с основным видео, чтобы отлавливать ховер внутри этих границ
      const leftBorder = ((this.value.startTime * this.scalingFactor) / this.speed) + this.canvasAxialOffset
      const rightBorder = ((this.value.finishTime * this.scalingFactor) / this.speed) + this.canvasAxialOffset
      const topBorder = this.axialHeight + this.tracksPadding
      const bottomBorder = this.axialHeight + this.tracksPadding + this.mainVideoTrackHeight

      // Просчитываем текущие координаты курсора
      const loc = this.windowToCanvas(this.$refs.timelineCanvas, event.clientX, event.clientY)

      // ховер по области видео, но не по краям этой области (затемнение тумбов и серая обводка)
      this.mainVideoTrackHover =
        loc.x >= leftBorder
        && loc.x <= rightBorder
        && loc.y >=topBorder
        && loc.y <=bottomBorder

      // ховер по левой границе области видео (желтая обводка)
      this.leftVideoBorderHover = Math.abs(leftBorder - loc.x) < 30 && loc.y >=topBorder && loc.y <=bottomBorder

      // ховер по правой границе области видео (желтая обводка)
      this.rightVideoBorderHover = Math.abs(rightBorder - loc.x) < 30 && loc.y >=topBorder && loc.y <=bottomBorder

      // перемещение левой отсечки видео
      if (this.cutOffMode === 'left') {
        this.$emit('startDrag', 'left')
        this.mainVideoTrackHover = true

        let newTime = (loc.x - 4.5) * this.speed / this.scalingFactor
        newTime = Math.floor(newTime * 100) / 100

        if (newTime >= this.value.finishTime - 1) {
          return
        }

        this.value.startTime =
          newTime < 0
            ? 0
            : newTime >= this.value.finishTime - 1
              ? this.value.finishTime - 1
              : newTime

        this.$emit("changeDuration", newTime)
      }

      // перемещение правой отсечки видео
      if (this.cutOffMode === 'right') {
        this.$emit('startDrag', 'right')
        this.mainVideoTrackHover = true

        const newTime = (loc.x - 4.5) * this.speed / this.scalingFactor

        if (newTime < this.value.startTime + 1) {
          return
        }

        this.value.finishTime =
          newTime > this.duration
            ? this.duration
            : newTime < this.value.startTime + 1
              ? this.value.startTime + 1
              : newTime

        this.$emit("changeDuration", newTime)
      }

      // перемещение плейхеда
      if (
        this.dragMode
        && loc.x > (this.value.startTime * this.scalingFactor / this.speed)
        && loc.x < (this.value.finishTime * this.scalingFactor / this.speed)
      ) {
        this.calculateTime(loc.x)
      }
    },
    canvasMouseleaveEventHandler() {
      if (this.cutOffMode) {
        this.$emit('stopDrag', this.value.startTime)
        this.cutOffMode = false
        this.played = true
      }

      this.dragMode = false
    },

    windowToCanvas(canvas, x, y) {
      const bbox = canvas.getBoundingClientRect()
      return { x: x - bbox.left * (canvas.width / bbox.width),
        y: y - bbox.top * (canvas.height / bbox.height)
      }
    },
    calculateTime(x) {
      const newTime = ((x - this.canvasAxialOffset) / this.scalingFactor) - this.value.startTime / this.speed
      this.$emit('changeTime', newTime)
    },
    /*
    * Инициализация канваса
    * */
    initCanvasTimeline() {
      this.animation = window.requestAnimationFrame(this.initCanvasTimeline)
      try {
        const canvas = this.$refs.timelineCanvas.getContext('2d')

        canvas.clearRect(0,0, this.canvasWidth, this.canvasHeight)

        this.drawTimelineBackground(canvas)
        this.drawTimelineAxial(canvas)
        this.drawCoordinateSerifs(canvas)
        this.drawMainVideoBlock(canvas)
        this.drawVideoThumbs(canvas)
        if (this.mainVideoTrackHover) {
          this.drawVideoTrackHover(canvas)
        }
        this.drawMainVideoBorders(canvas)
        this.drawMainVideoOverlay(canvas)
        this.drawTimelinePlayhead(canvas)
      } catch (err) {
        console.log(err)
        this.destroyCanvas()
        return
      }
    },
    /**
     * Рисуем задний фон для таймлайна
     * @param { object } canvas - контекст канваса
     * */
    drawTimelineBackground(canvas) {
      canvas.fillStyle = "#3f3f3f"
      canvas.fillRect(0,0, this.canvasWidth, this.canvasHeight)
    },
    /**
     * Рисуем осевую линию
     * @param { object } canvas - контекст канваса
     * */
    drawTimelineAxial(canvas) {
      canvas.fillStyle = '#6c6c6c'
      canvas.lineWidth = 1.0
      canvas.beginPath()
      canvas.moveTo(0, 0.5)
      canvas.lineTo(this.canvasWidth, 0)
      canvas.strokeStyle = '#6c6c6c'
      canvas.stroke()
      canvas.closePath()
    },
    /**
     * Рисуем координаты и засечки
     * @param { object } canvas - контекст канваса
     * */
    drawCoordinateSerifs(canvas) {
      for (let i = 0; i < this.canvasWidth; i += this.scalingFactor) {
        let currentCoordinate = i + 5
        let currentNumber = i / this.scalingFactor
        if (currentNumber % 5 === 0) {
          canvas.fillText(currentNumber, currentCoordinate - (canvas.measureText(currentNumber).width / 2), 17)
        }
        canvas.beginPath()
        canvas.moveTo(currentCoordinate - 0.5, 0)
        canvas.lineTo(currentCoordinate - 0.5, 6)
        canvas.stroke()
        canvas.closePath()
      }
    },
    /**
     * Рисуем основной блок с видео
     * @param { object } canvas - контекст канваса
     * */
    drawMainVideoBlock(canvas) {
      // Рисуем прямоугольник, на котором будет расположена дорожка с видео
      canvas.fillStyle = '#454545'
      canvas.fillRect(0, this.mainVideoTrackMargin, this.canvasWidth, this.mainVideoTrackHeight)
      // const videoBlockWidth = (this.duration * this.scalingFactor) / this.speed
      // canvas.fillStyle = '#6c6c6c'
      // canvas.beginPath()
      // canvas.arc(7, 30, 4, Math.PI, Math.PI * 1.5)
      // canvas.lineTo(3 + videoBlockWidth, 26)
      // canvas.arc(3 + videoBlockWidth, 30, 4, Math.PI * 1.5, Math.PI * 2)
      // canvas.lineTo(3 + videoBlockWidth + 4, 78)
      // canvas.arc(3 + videoBlockWidth, 78, 4, 0, Math.PI * 0.5)
      // canvas.lineTo(7, 82)
      // canvas.arc(7, 78, 4, Math.PI * 0.5, Math.PI)
      // // canvas.fillRect(5, 26, (this.duration * this.scalingFactor) / this.speed, 56)
      // canvas.fill()
      // canvas.closePath()
    },
    /**
     * Рисуем обводку поверх тумб
     * @param { object } canvas - контекст канваса
     */
    drawMainVideoBorders(canvas) {
      canvas.fillStyle = '#454545'
      canvas.fillRect(
        this.canvasAxialOffset,
        this.mainVideoTrackMargin,
        this.value.startTime * this.scalingFactor / this.speed,
        this.mainVideoTrackHeight,
      )
      canvas.fillRect(
        this.value.finishTime * this.scalingFactor / this.speed + this.canvasAxialOffset,
        this.mainVideoTrackMargin,
        (Math.ceil(this.duration) - this.value.finishTime) / this.speed * this.scalingFactor ,
        this.mainVideoTrackHeight,
      )
    },
    /**
     * Рисуем тумбы для дорожки с видео
     * @param { object } canvas - контекст канваса
     * */
    drawVideoThumbs(canvas) {
      for (let i = 0; i <= this.duration; i++) {
        if (this.thumbs[i] && this.thumbs[i] !== 'In progress') {
          // console.log(`(+) Тумба для ${i} секунды есть, загружаю`)
          this.drawThumbOnCanvas(i, this.thumbs[i], canvas)
        }
      }
    },
    async checkThumbsStatus() {
      this.runningProcesses = Object.values(this.thumbs).filter(thumb => thumb === 'In progress').length

      for (let i = 0; i <= this.duration; i++) {
        if (!this.thumbs[i]) {
          this.thumbs[i] = 'In progress'
          this.thumbs[i] = await this.generateVideoThumb(i)
          this.runningProcesses += 1
        }
      }

      console.groupEnd()
    },
    drawThumbOnCanvas(second, imgData, canvas) {
      // Координата по оси X верхнего левого угла фрагмента, который будет
      // вырезан из изображения-источника и помещён в контекст-приёмник.
      let sx = undefined

      // Координата по оси Y верхнего левого угла фрагмента, который будет
      // вырезан из изображения-источника и помещён в контекст-приёмник.
      let sy = undefined

      // Ширина фрагмента, который будет вырезан из изображения источника и помещён в
      // контекст-приёмник. Если не задана, фрагмент от точки, заданной sx и sy до
      // правого нижнего угла источника будет целиком скопирован в контекст-приёмник.
      let sWidth = undefined

      // Высота фрагмента, который будет вырезан из изображения
      // источника и помещён в контекст-приёмник.
      let sHeight = undefined

      // Координата по оси Х, обозначающая стартовую точку холста-приёмника,
      // в которую будет помещён верхний левый угол исходного image.
      let dx = undefined

      // Координата по оси Y, обозначающая стартовую точку холста-приёмника,
      // в которую будет помещён верхний левый угол исходного image.
      let dy = undefined

      // Ширина изображения, полученного из исходного image.
      // Эта опция позволяет масштабировать изображение по ширине.
      // Если опция не задана, изображение не будет масштабировано.
      let dWidth = undefined

      // Высота изображения, полученного из исходного image.
      // Эта опция позволяет масштабировать изображение по высоте.
      // Если опция не задана, изображение не будет масштабировано.
      let dHeight = undefined

      // Вычисляем корректную область изображения, необходимую для тумбы,
      // а так же ее соотношение сторон
      dWidth = this.scalingFactor / this.speed
      dHeight = this.mainVideoTrackHeight
      dx = second * this.scalingFactor / this.speed + this.canvasAxialOffset
      dy = this.mainVideoTrackMargin
      const thumbAspectRatio = dWidth / dHeight


      if (imgData.naturalHeight * thumbAspectRatio < imgData.naturalWidth) {

        sHeight = imgData.naturalHeight
        sWidth = sHeight * thumbAspectRatio
        sy = 0
        sx = (imgData.naturalWidth - sWidth) / 2
      }

      if (imgData.naturalHeight * thumbAspectRatio >= imgData.naturalWidth) {

        sWidth = imgData.naturalWidth
        sHeight = sWidth / thumbAspectRatio
        sx = 0
        sy = (imgData.naturalHeight - sHeight) / 2
      }

      canvas.drawImage(imgData, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
    },
    generateVideoThumb(second) {
      // console.log(`(+) - Генерирую изображение для ${second} секунды`)
      return new Promise((resolve, reject) => {
        const videoContainer = document.createElement('video')
        videoContainer.setAttribute('src', this.source)
        videoContainer.setAttribute('crossOrigin', 'anonymous')
        videoContainer.load()
        videoContainer.addEventListener('error', (ex) => {
          reject(`(-) Ошибка обработки видео - ${ex}`)
        })
        videoContainer.addEventListener('loadedmetadata', () => {
          if (videoContainer.duration < second) {
            reject('(-) Видео короче заданной секунды')
            return
          }
          setTimeout(() => {
            videoContainer.currentTime = second + 0.5
          }, 200)
          videoContainer.addEventListener('seeked', () => {
            // console.log(`(+) Видео на паузе на ${second}`)
            const canvas = document.createElement('canvas')
            canvas.width = videoContainer.videoWidth
            canvas.height = videoContainer.videoHeight
            const ctx = canvas.getContext('2d')
            ctx.drawImage(videoContainer, 0, 0, canvas.width, canvas.height)
            ctx.canvas.toBlob(
              blob => {
                const newImg = document.createElement('img'),
                  url = URL.createObjectURL(blob)
                newImg.onload = () => {
                  URL.revokeObjectURL(url)
                }
                newImg.src = url
                resolve(newImg)
              },
              'image/jpeg',
              0.05,
            )
          })
        })
      })
    },
    /**
     * Рисуем плейхед для таймлайна
     * @param { object } canvas - контекст канваса
     * */
    drawTimelinePlayhead(canvas) {
      const currentPositionX = (this.value.startTime / this.speed + this.currentTime) * this.scalingFactor + this.canvasAxialOffset
      canvas.fillStyle = '#fdcf30'

      canvas.beginPath()
      canvas.moveTo(currentPositionX - 6, 6.5)
      canvas.lineTo(currentPositionX - 6, 2)
      canvas.arc(
        currentPositionX - 4,
        2,
        2,
        Math.PI,
        Math.PI * 1.5)
      canvas.lineTo(currentPositionX + 4, 0)
      canvas.arc(
        currentPositionX + 4,
        2,
        2,
        Math.PI * 1.5,
        Math.PI * 2)
      canvas.lineTo(currentPositionX + 6, 6.5)
      canvas.lineTo(currentPositionX, 14)

      canvas.closePath()
      canvas.fill()

      // Рисуем вертикальную палку
      canvas.fillRect(currentPositionX - 1, 0, 2,99)
    },
    /**
     * Рисуем полупрозрачный ховер на дорожку с видео
     */
    drawVideoTrackHover(canvas) {
      canvas.fillStyle = 'rgba(0, 0, 0, 0.5)'
      canvas.fillRect(
        this.value.startTime / this.speed * this.scalingFactor + this.canvasAxialOffset,
        this.mainVideoTrackMargin,
        (this.value.finishTime - this.value.startTime) / this.speed * this.scalingFactor,
        this.mainVideoTrackHeight
      )

      this._drawCaptureIcon(
        canvas,
        (this.value.startTime / this.speed * this.scalingFactor) + this.canvasAxialOffset + 4,
        this.mainVideoTrackMargin + 18
      )
      this._drawCaptureIcon(
        canvas,
        (this.value.startTime / this.speed * this.scalingFactor) + this.canvasAxialOffset + 9,
        this.mainVideoTrackMargin + 18
      )

      this._drawCaptureIcon(
        canvas,
        (this.value.finishTime / this.speed * this.scalingFactor) - 4,
        this.mainVideoTrackMargin + 18
      )
      this._drawCaptureIcon(
        canvas,
        (this.value.finishTime / this.speed * this.scalingFactor) - 9,
        this.mainVideoTrackMargin + 18
      )
    },
    /**
     * Рисуем прямоугольник, для обозначения области захвата края дорожки (см макеты)
     */
    _drawCaptureIcon(canvas, dx, dy) {
      canvas.fillStyle = '#fff'
      canvas.beginPath()
      canvas.arc(
        dx + 1,
        dy + 1,
        1,
        Math.PI,
        Math.PI * 3 / 2,
      )
      canvas.lineTo(dx + 2, dy)
      canvas.arc(
        dx + 2,
        dy + 1,
        1,
        Math.PI * 3 / 2,
        Math.PI * 2,
      )
      canvas.lineTo(dx + 3, dy + 19)
      canvas.arc(
        dx + 2,
        dy + 19,
        1,
        Math.PI * 2,
        Math.PI * 2 + Math.PI / 2,
      )
      canvas.lineTo(dx + 1, dy + 20)
      canvas.arc(
        dx + 1,
        dy + 19,
        1,
        Math.PI * 2 + Math.PI / 2,
        Math.PI * 2 + Math.PI
      )
      canvas.closePath()
      canvas.fill()

    },
    /**
     * Рисуем перетаскиваемый оверлей для основного видео
     * */
    drawMainVideoOverlay(canvas) {
      const videoBlockWidth = ((this.value.finishTime - this.value.startTime) * this.scalingFactor) / this.speed

      const borderRadius = 4

      if (this.mainVideoTrackHover) {
        canvas.strokeStyle = '#8F8F8F'
      }

      if (this.rightVideoBorderHover || this.leftVideoBorderHover) {
        canvas.strokeStyle = '#FFD648'
      }

      if (!this.leftVideoBorderHover && !this.rightVideoBorderHover && !this.mainVideoTrackHover) {
        canvas.strokeStyle = '#6c6c6c'
      }

      canvas.lineWidth = 2

      canvas.beginPath()
      canvas.arc(
        this.value.startTime / this.speed * this.scalingFactor + borderRadius + this.canvasAxialOffset,
        this.mainVideoTrackMargin + borderRadius,
        borderRadius,
        Math.PI,
        Math.PI * 1.5,
        false,
      )
      canvas.lineTo(this.value.finishTime / this.speed * this.scalingFactor - borderRadius, this.mainVideoTrackMargin)
      canvas.arc(
        this.value.finishTime / this.speed * this.scalingFactor,
        this.mainVideoTrackMargin + borderRadius,
        borderRadius,
        Math.PI * 1.5,
        Math.PI * 2,
        false,
      )
      canvas.lineTo(this.value.finishTime / this.speed * this.scalingFactor + this.canvasAxialOffset, this.mainVideoTrackMargin + this.mainVideoTrackHeight - borderRadius)
      canvas.arc(
        this.value.finishTime / this.speed * this.scalingFactor + this.canvasAxialOffset - borderRadius,
        this.mainVideoTrackMargin + this.mainVideoTrackHeight - borderRadius,
        borderRadius,
        Math.PI * 2,
        Math.PI * 2.5,
        false,
      )
      canvas.lineTo(this.value.startTime / this.speed * this.scalingFactor + this.canvasAxialOffset + borderRadius, this.mainVideoTrackMargin + this.mainVideoTrackHeight)
      canvas.arc(
        this.value.startTime / this.speed * this.scalingFactor + this.canvasAxialOffset + borderRadius,
        this.mainVideoTrackMargin + this.mainVideoTrackHeight - borderRadius,
        borderRadius,
        Math.PI * 2.5,
        Math.PI * 3,
        false,
      )
      canvas.closePath()
      canvas.stroke()
    },
    destroyCanvas() {
      window.cancelAnimationFrame(this.animation)
      this.animation = undefined
    }
  },
  mounted() {
    this.openedSourceId = this.id
    console.log('Canvas inited...')
    this.initCanvasTimeline()
    this.$emit('canvasInit')

    // TODO стоит задержка, т.к. сразу в хуке вылетает циклическая ошибка.
    setTimeout(() => {
      this.fitButtonClickHandler()
    }, 1000)

    this.checkThumbsStatus()

    // this.thumbsCheckInterval = setInterval(this.checkThumbsStatus, 10000)
  },
  beforeUpdate() {
    if (this.openedSourceId !== this.id) {
      console.log('(+)')
      this.openedSourceId = this.id
      this.played = false
      this.thumbs = {}
      this.$emit('canvasInit')

      // TODO стоит задержка, т.к. сразу в хуке вылетает циклическая ошибка.
      setTimeout(() => {
        this.fitButtonClickHandler()
      }, 1000)

      this.checkThumbsStatus()
    }
  },
  beforeDestroy() {
    this.destroyCanvas()
    // clearInterval(this.thumbsCheckInterval)
    this.thumbs = {}
    return
  },
}
</script>

<style lang="scss">
.timeline {
  margin: 0;
  padding: 0;
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  background-color: $color-gray-1;
}

.timeline__header {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.timeline__play-button {
  margin: 0 0 0 53%;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;

  background: transparent;
  border: none;

  cursor: pointer;
}

.timeline__current-times {
  margin: 0 0 0 16px;
  padding: 0;

  /* Body small */

  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
}

.timeline__zoom-in,
.timeline__zoom-out,
.timeline__max-zoom-out {
  margin: 0 16px 0 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  background: transparent;
  border: none;

  cursor: pointer;
}

.timeline__zoom-in {
  margin-left: auto;
}

.timeline__zoom-in,
.timeline__zoom-out, {
  width: 12px;
  height: 12px;
}

.timeline__zoom-in,
.timeline__zoom-out {
  path {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    & path {
      stroke: $color-yellow-hover;
    }
  }
}

.timeline__play-button,
.timeline__mute-toggle,
.timeline__max-zoom-out {
  path,
  rect {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    & path,
    & rect {
      fill: $color-yellow-hover;
    }
  }
}

.timeline__canvas-wrapper {
  margin: auto 0 0;
  padding: 0;
  width: 100%;
  height: 99px;

  overflow-x: scroll;
  overflow-y: hidden;
}

.timeline__canvas {
  margin: 0;
  padding: 0;

  cursor: pointer;
}
</style>

<!--<template>-->
<!--  <div class="component" :class="{ _disabled: disabled }">-->
<!--    <div class="time-points-container">-->
<!--      <div class="time-points">-->
<!--        <div-->
<!--          class="time-points__point"-->
<!--          :style="{-->
<!--            left: (i / (duration / speed)) * 100 + '%',-->
<!--          }"-->
<!--          v-for="(point, i) in Array(Math.ceil(duration / speed + 1))"-->
<!--          :key="i"-->
<!--        >-->
<!--          {{ i % 5 === 0 ? i : " " }}-->
<!--          <div class="time-points__point__line"></div>-->
<!--        </div>-->
<!--        &lt;!&ndash;       <div-->
<!--        class="time-points__point"-->
<!--        :style="{-->
<!--          left: '100%',-->
<!--        }"-->
<!--      >-->
<!--        {{-->
<!--          duration - Math.ceil(duration) !== 0 &&-->
<!--          duration - Math.ceil(duration) <= 1-->
<!--            ? ""-->
<!--            : Math.round(duration * 100) / 100-->
<!--        }}-->
<!--        <div class="time-points__point__line"></div>-->
<!--      </div> &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--    <div style="overflow: hidden; width: 100%; heidght: 100%">-->
<!--      <div class="slide-container" ref="gap">-->
<!--        <div class="slide-container__background">-->
<!--          <div class="slide-container__background__snapshots" ref="snapshots">-->
<!--            <ResizeObserver @notify="onResize" />-->
<!--            <canvas v-if="!thumbs" id="canvas" width="288" height="50"></canvas>-->
<!--            <img-->
<!--              v-for="thumbSource in thumbs"-->
<!--              :key="thumbSource"-->
<!--              :src="$baseURL + thumbSource"-->
<!--              :style="{-->
<!--                width: 'calc(100% / ' + thumbs.length + ')',-->
<!--                position: 'relative',-->
<!--                objectFit: 'cover',-->
<!--              }"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          class="slide-container__range-gap"-->
<!--          :class="{-->
<!--            _active: isDragLeft || isDragRight,-->
<!--            _changed: relativeWidth !== 100,-->
<!--          }"-->
<!--          :style="{-->
<!--            width: relativeWidth + '%',-->
<!--            minWidth: relativeWidth + '%',-->
<!--            left: leftPosition,-->
<!--          }"-->
<!--        >-->
<!--          <span-->
<!--            class="slide-container__range-gap__before"-->
<!--            @mousedown="onStartDrag('left', $event)"-->
<!--          >-->
<!--            <div class="icon"></div>-->
<!--          </span>-->
<!--          <span-->
<!--            class="slide-container__range-gap__after"-->
<!--            @mousedown="onStartDrag('right', $event)"-->
<!--          >-->
<!--            <div class="icon"></div>-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script lang="ts">-->
<!--import { ResizeObserver } from "vue-resize";-->

<!--export default {-->
<!--  name: "BaseVideoRangeSlider",-->
<!--  components: {-->
<!--    ResizeObserver,-->
<!--  },-->
<!--  data: function () {-->
<!--    return {-->
<!--      isDragLeft: false,-->
<!--      isDragRight: false,-->
<!--    };-->
<!--  },-->
<!--  computed: {-->
<!--    relativeWidth: function () {-->
<!--      return (-->
<!--        ((this.value.finishTime - this.value.startTime) * 100) / this.duration-->
<!--      );-->
<!--    },-->
<!--    leftPosition: function () {-->
<!--      return (this.value.startTime * 100) / this.duration + "%";-->
<!--    },-->
<!--  },-->
<!--  mounted() {-->
<!--    this.onResize();-->
<!--  },-->
<!--  watch: {-->
<!--    source: function () {-->
<!--      this.$forceUpdate();-->
<!--      this.onResize();-->
<!--    },-->
<!--  },-->
<!--  props: {-->
<!--    source: {-->
<!--      type: String,-->
<!--      required: true,-->
<!--    },-->
<!--    duration: {-->
<!--      type: Number,-->
<!--      required: true,-->
<!--    },-->
<!--    speed: {-->
<!--      type: Number,-->
<!--      required: true,-->
<!--    },-->
<!--    value: {-->
<!--      type: Object,-->
<!--      required: true,-->
<!--    },-->
<!--    thumbs: {-->
<!--      type: Array,-->
<!--      required: false,-->
<!--    },-->
<!--    disabled: {-->
<!--      type: Boolean,-->
<!--      default: false,-->
<!--    },-->
<!--  },-->
<!--  methods: {-->
<!--    onResize() {-->
<!--      if (!this.thumbs) {-->
<!--        let canvas = <HTMLCanvasElement>document.getElementById("canvas");-->
<!--        canvas.width = this.$refs.snapshots-->
<!--          ? this.$refs.snapshots.getBoundingClientRect().width-->
<!--          : 0;-->
<!--        this.updateCanvasBySource(10);-->
<!--      }-->
<!--    },-->
<!--    updateCanvasBySource(count) {-->
<!--      let canvas = <HTMLCanvasElement>document.getElementById("canvas"); //<HTMLCanvasElement>document.createElement("CANVAS");-->
<!--      let ctx = canvas.getContext("2d");-->
<!--      let cw = canvas.width;-->
<!--      let ch = canvas.height;-->

<!--      let position = 0;-->

<!--      let v = <HTMLVideoElement>document.createElement("video");-->
<!--      v.muted = true;-->
<!--      v.src = this.source;-->
<!--      v.play();-->

<!--      v.addEventListener(-->
<!--        "loadedmetadata",-->
<!--        async function () {-->
<!--          let x, y;-->
<!--          x = 0;-->
<!--          y = 0;-->

<!--          let seekResolve;-->
<!--          v.addEventListener("seeked", async function () {-->
<!--            if (seekResolve) seekResolve();-->
<!--          });-->

<!--          let frameWidth = cw / count;-->
<!--          let range = this.duration / count;-->
<!--          ctx.clearRect(x, y, cw, ch);-->
<!--          for (let i = 0; i < count; i++) {-->
<!--            v.currentTime = range * i;-->
<!--            await new Promise((r) => (seekResolve = r));-->
<!--            ctx.drawImage(v, x, y, frameWidth, ch);-->
<!--            x += frameWidth;-->
<!--          }-->
<!--        },-->
<!--        false-->
<!--      );-->
<!--    },-->
<!--    onStartDrag(side, event) {-->
<!--      if (this.disabled) {-->
<!--        return;-->
<!--      }-->
<!--      this.$emit("startDrag", side);-->
<!--      console.log("start-drag");-->
<!--      this.isDragLeft = side === "left";-->
<!--      this.isDragRight = side === "right";-->
<!--      window.onmousemove = this.moveAt.bind(event);-->
<!--      window.onmouseup = this.myDragStop.bind(event);-->
<!--    },-->
<!--    moveAt(event) {-->
<!--      event.preventDefault();-->
<!--      if (this.disabled) {-->
<!--        return;-->
<!--      }-->
<!--      console.log("drag");-->
<!--      let newTime = 0;-->
<!--      //min 1 sec-->
<!--      //TODO if video less than 1 sec-->
<!--      if (this.isDragLeft) {-->
<!--        newTime =-->
<!--          this.value.startTime +-->
<!--          (event.movementX / this.$refs.gap.offsetWidth) * this.duration;-->
<!--        newTime = Math.floor(newTime * 100) / 100;-->
<!--        this.value.startTime =-->
<!--          newTime < 0-->
<!--            ? 0-->
<!--            : newTime > this.value.finishTime - 1-->
<!--            ? this.value.finishTime - 1-->
<!--            : newTime;-->
<!--      } else if (this.isDragRight) {-->
<!--        newTime =-->
<!--          this.value.finishTime +-->
<!--          (event.movementX / this.$refs.gap.offsetWidth) * this.duration;-->
<!--        newTime = Math.floor(newTime * 100) / 100;-->
<!--        this.value.finishTime =-->
<!--          newTime > this.duration-->
<!--            ? this.duration-->
<!--            : newTime < this.value.startTime + 1-->
<!--            ? this.value.startTime + 1-->
<!--            : newTime;-->
<!--      }-->
<!--      this.$emit("changeDuration", newTime);-->
<!--      console.log(this.value.startTime + "  " + this.value.finishTime);-->
<!--    },-->
<!--    myDragStop() {-->
<!--      if (this.disabled) {-->
<!--        return;-->
<!--      }-->
<!--      console.log("stop-drag");-->
<!--      window.onmouseup = null;-->
<!--      this.isDragLeft = false;-->
<!--      this.isDragRight = false;-->
<!--      window.onmousemove = null;-->
<!--      this.$emit("z`", this.value.startTime);-->
<!--    },-->
<!--  },-->
<!--};-->
<!--</script>-->

<!--<style scoped lang="scss">-->
<!--.component {-->
<!--  display: flex;-->
<!--  width: 100%;-->
<!--  height: 100%;-->
<!--  //overflow: hidden;-->
<!--  border-radius: 4px;-->

<!--  &._disabled {-->
<!--    opacity: 0.4;-->
<!--    pointer-events: none;-->
<!--  }-->
<!--}-->

<!--.time-points-container {-->
<!--  position: absolute;-->
<!--  top: -15px;-->
<!--  width: 100%;-->
<!--  height: 15px;-->
<!--  display: flex;-->
<!--  flex-direction: row;-->
<!--  overflow: hidden;-->
<!--}-->

<!--.time-points {-->
<!--  position: relative;-->
<!--  width: calc(100% - 36px);-->
<!--  height: 15px;-->
<!--  margin: 0 18px;-->
<!--  display: flex;-->
<!--  flex-direction: row;-->

<!--  &__point {-->
<!--    position: absolute;-->
<!--    width: 15px;-->
<!--    height: 15px;-->
<!--    display: flex;-->
<!--    flex-direction: column;-->
<!--    align-items: center;-->
<!--    justify-content: start;-->

<!--    margin-left: -7.5px;-->

<!--    font-family: Roboto;-->
<!--    font-style: normal;-->
<!--    font-weight: normal;-->
<!--    font-size: 9px;-->
<!--    line-height: 8px;-->
<!--    color: $color-gray-5;-->

<!--    &__line {-->
<!--      background: $color-gray-4;-->
<!--      width: 1px;-->
<!--      height: 5px;-->
<!--      min-height: 5px;-->
<!--      min-width: 1px;-->
<!--      bottom: 0;-->
<!--      position: absolute;-->
<!--    }-->
<!--  }-->
<!--}-->

<!--.slide-container {-->
<!--  width: calc(100% - 36px);-->
<!--  height: 100%;-->
<!--  display: flex;-->
<!--  position: relative;-->
<!--  border-radius: 4px;-->
<!--  margin: 0 18px;-->
<!--  user-select: none;-->

<!--  &__background {-->
<!--    background-color: $color-gray-1;-->
<!--    width: 100%;-->
<!--    height: 100%;-->
<!--    border-radius: 4px;-->
<!--    border-top: 4px solid $color-gray-5;-->
<!--    border-bottom: 4px solid $color-gray-5;-->
<!--    box-sizing: border-box;-->
<!--    //box-shadow: 0px 0px 0px 1px white;-->

<!--    &__snapshots {-->
<!--      display: flex;-->
<!--      width: 100%;-->
<!--      height: 100%;-->
<!--      flex-direction: row;-->

<!--      overflow: hidden;-->
<!--    }-->
<!--  }-->

<!--  &__range-gap {-->
<!--    position: absolute;-->
<!--    height: 100%;-->
<!--    border-top: 4px solid $color-gray-5;-->
<!--    border-bottom: 4px solid $color-gray-5;-->
<!--    box-sizing: border-box;-->

<!--    &:before,-->
<!--    &:after {-->
<!--      content: "";-->
<!--      position: absolute;-->
<!--      background-color: $color-gray-3;-->
<!--      opacity: 0.8;-->
<!--      width: 1000px;-->
<!--      height: calc(100% + 8px);-->
<!--      top: -4px;-->
<!--    }-->

<!--    &:before {-->
<!--      left: calc(-1000px - 18px);-->
<!--    }-->

<!--    &:after {-->
<!--      right: calc(-1000px - 18px);-->
<!--    }-->

<!--    &._active,-->
<!--    &._changed {-->
<!--      border-color: $color-yellow;-->

<!--      .slide-container__range-gap__before,-->
<!--      .slide-container__range-gap__after {-->
<!--        border-color: $color-yellow;-->
<!--        background-color: $color-yellow;-->
<!--        &:hover {-->
<!--          border-color: $color-yellow-hover;-->
<!--          background-color: $color-yellow-hover;-->

<!--          .icon {-->
<!--            background-color: $color-gray-2;-->
<!--          }-->
<!--        }-->
<!--        .icon {-->
<!--          background-color: $color-gray-1;-->
<!--        }-->
<!--      }-->
<!--    }-->

<!--    &__before,-->
<!--    &__after {-->
<!--      content: "";-->
<!--      position: absolute;-->
<!--      height: 100%;-->
<!--      width: 10px;-->

<!--      top: -4px;-->

<!--      border: 4px solid $color-gray-5;-->
<!--      background-color: $color-gray-5;-->

<!--      cursor: col-resize;-->
<!--    }-->

<!--    &__before:hover,-->
<!--    &__after:hover {-->
<!--      border-color: $color-gray-6;-->
<!--      background-color: $color-gray-6;-->
<!--    }-->

<!--    &__before {-->
<!--      left: -18px;-->
<!--      border-radius: 4px 0px 0px 4px;-->

<!--      .icon {-->
<!--        height: 100%;-->
<!--        width: 100%;-->
<!--        @include mask-image(-->
<!--          url("~assets/new-icons/thin-arrow-right-icon.svg"),-->
<!--          $color-font-basic,-->
<!--          8px-->
<!--        );-->
<!--        transform: rotate(-180deg);-->
<!--      }-->
<!--    }-->

<!--    &__after {-->
<!--      right: -18px;-->
<!--      border-radius: 0px 4px 4px 0px;-->

<!--      .icon {-->
<!--        height: 100%;-->
<!--        width: 100%;-->
<!--        @include mask-image(-->
<!--          url("~assets/new-icons/thin-arrow-right-icon.svg"),-->
<!--          $color-font-basic,-->
<!--          8px-->
<!--        );-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</style>-->